module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0000_01_Landing.d462320.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0000_01_Landing.jpg
// module id = a0jz
// module chunks = 0